import EconomicCalendar from '../../components/common/EconomicCalendar';

const UserEconomicCalendar = () => {
  return <EconomicCalendar />;
};

export default UserEconomicCalendar;
